import { Dialog } from '@cimplico/components';
import { useState } from 'react';
import ProcedureCategorySelect from '../../components/procedure-category-select/ProcedureCategorySelect';
import { toastNotification } from '../../components/toast/Toast';
import { useUpdateProcedures } from '../../queries/use-update-procedures';

type AssignToCategoryConfirmProps = {
    templateId: string;
    procedureIds: string[];
    isOpen: boolean;
    onClose: () => void;
    onAssign: () => void;
};

function AssignToCategoryConfirm({ templateId, procedureIds, isOpen, onClose, onAssign }: AssignToCategoryConfirmProps): JSX.Element {
    const [category, setCategory] = useState<string | undefined>();
    const updateProceduresQuery = useUpdateProcedures(templateId);

    function assignProcedure(): void {
        if (!category) {
            onClose();
            return;
        }
        updateProceduresQuery.mutate(
            procedureIds.map((p) => ({
                id: p,
                fields: {
                    categoryId: category,
                },
            })),
            {
                onSuccess: () => {
                    onAssign();
                    toastNotification(
                        'success',
                        `${procedureIds.length} ${procedureIds.length === 1 ? 'procedure' : 'procedures'} assigned to new category!`
                    );
                },
            }
        );
    }

    return (
        <Dialog
            type="info"
            title="Assign procedures to a category"
            description="Select the category you wish to assign the selected procedures to. If a selected procedure already belongs to a category, it will be overridden."
            isOpen={isOpen}
            primaryAction="Assign"
            secondaryAction="Cancel"
            onClose={onClose}
            onSecondaryActionClick={onClose}
            onPrimaryActionClick={assignProcedure}
            isLoading={updateProceduresQuery.isLoading}
        >
            <div className="pr-6 pb-4">
                <ProcedureCategorySelect templateId={templateId} onChange={(v): void => setCategory(v[0])} />
            </div>
        </Dialog>
    );
}

export default AssignToCategoryConfirm;
